export default __webpack_public_path__ + "fc274a63a51d2e1e72e6f503d2ecc152.png";